import React from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';

const MapHeader = ({ coordinates, handleClose }) => {
  const translate = useIntl();
  return (
    <div className="map__box-info">
      { /* eslint-disable-next-line react/jsx-one-expression-per-line */ }
      <div>Longitude: {coordinates.longitude} | Latitude: {coordinates.latitude} | Zoom: {coordinates.zoom}</div>
      <div className="map__btn-wrapper">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-back' })}
          handleClick={handleClose}
          type="button"
          customClass="btn__cancel"
        />
      </div>
    </div>
  );
};

export default MapHeader;
